import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { Parallax } from "@/components/atoms/Parallax";

interface Props {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title = "Nothing here yet", description, icon, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 animate-riseIn motion-reduce:animate-none">
      <Parallax speed={24}>
        <div className="h-12 w-12 rounded-full bg-bridge-panel/70 border border-bridge-border/70 flex items-center justify-center text-bridge-muted">
          {icon ?? <Inbox size={20} />}
        </div>
      </Parallax>
      <h3 className="mt-4 text-base font-semibold text-bridge-fg">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-bridge-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}